import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=84aa8128"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=84aa8128&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports